import { Field, FieldConfig } from "formik";
import ValidationErrorMessage from "../ValidationErrorMessage";
import IsRequired from "../common/IsRequired";

export interface IValidatedField extends FieldConfig<any> {
  label: string;
  id: string;
  name: string;
  isRequired?: boolean;
  children?: React.ReactNode;
}

export default function LabelledFieldWithValidation(props: IValidatedField) {
  const { label, isRequired, id, name } = props;

  return (
    <Field name={name} id={id} label="Adresselinje 1">
      {({
        field,
        // form,
        meta,
      }) => {
        const wasTouched = meta.touched;
        const errorMessage = meta.error;
        return (
          <>
            <label
              htmlFor={id}
              className="form-label"
              style={{ whiteSpace: "nowrap" }}
            >
              {label}
              {isRequired && <IsRequired />}
            </label>
            <input
              {...field}
              className={`form-control${
                errorMessage && wasTouched ? " is-invalid" : ""
              }`}
            />
            <ValidationErrorMessage
              touched={wasTouched}
              errorMessage={errorMessage}
            />
          </>
        );
      }}
    </Field>
  );
}
